// Globalny stan aplikacji - CMS
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ICmsArticlesFilters {
  page?: number;
  limit?: number;
  search_keyword?: string;
  section_id?: number | null;
}

// typ cms
interface ICmsSlice {
  // Filtry dla listy artykułów
  articlesFilters?: ICmsArticlesFilters;
}

// dane inicjalizacyjne
const initialState: ICmsSlice = {
  articlesFilters: undefined
};

export const cmsSlice = createSlice({
  name: 'cms',
  initialState,
  reducers: {
    setArticlesFilters: (
      state,
      action: PayloadAction<ICmsArticlesFilters>
    ) => {
      state.articlesFilters = action.payload;
    }
  }
});

export const cmsSliceActions = cmsSlice.actions;

export default cmsSlice.reducer;
